'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var UserAvatar = function UserAvatar(_ref) {
  var entitlements = _ref.entitlements;

  var getRingClassName = function getRingClassName() {
    return (0, _classnames2.default)({
      'quiver-user-avatar__ring': true,
      'quiver-user-avatar__ring--premium': !!entitlements.includes('sl_premium')
    });
  };

  return _react2.default.createElement(
    'svg',
    {
      className: 'quiver-user-avatar',
      width: '34px',
      height: '34px',
      role: 'img',
      viewBox: '0 0 34 34',
      'aria-label': '[title]',
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle' }
    },
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(1.000000, 1.000000)'
      },
      _react2.default.createElement('circle', { stroke: '#FFFFFF', cx: '16', cy: '13.6', r: '6.1' }),
      _react2.default.createElement('path', {
        d: 'M26.4493244,27.5833333 C25.9299768,25.0267564 21.4813083,22.9 16,22.9 C10.5186917,22.9 6.07002319,25.0267564 5.55067563,27.5833333',
        stroke: '#FFFFFF'
      }),
      _react2.default.createElement('circle', {
        className: getRingClassName(),
        strokeWidth: '2',
        cx: '16',
        cy: '16',
        r: '16'
      })
    )
  );
};

UserAvatar.propTypes = {
  entitlements: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

UserAvatar.defaultProps = {
  entitlements: []
};

exports.default = UserAvatar;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/UserAvatar/UserAvatar.js
// module id = 694
// module chunks = 11